import React, { useEffect, useState, useRef } from "react";
import { Panel } from 'primereact/panel';
import { genPhotoList, genPhotoUpdate } from "../../../service/GEN/GenService";
import { Loading } from "../../../components/Loading/Loading";
import { Galleria } from 'primereact/galleria';
import Media from "../../../components/Media/Media";
import { Button } from "primereact/button";
import { DialogShow } from "../../../components/DialogService/DialogService";
import P206DeletePicList from "./P206DeletePicList";
export default function Panel_H({ searchData, tabCode, data, uploadPic }) {

    const [loading, setLoading] = useState(false);
    const [errData, setErrData] = useState(null);
    const [dataT001, setDataT001] = useState([]);
    const [dataT002, setDataT002] = useState([]);
    const [dataT003, setDataT003] = useState([]);
    const [dataT004, setDataT004] = useState([]);
    const [dataT005, setDataT005] = useState([]);
    const [dataT006, setDataT006] = useState([]);
    const [showDialog, setShowDialog] = useState(false);
    const [dialogPics, setDialogPics] = useState({ dialog: false, show: false });
    const toast = useRef(null);
    const [dataList, setDataList] = useState([]);
    //const [tabCodes, setTabCodes] = useState("");

    const [textShow, setTextShow] = useState("");


    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };


    useEffect(() => {
        onGenPhotoList();
    }, []);

    const onGenPhotoList = () => {
        let req = {
            photoType: "",
            requestNo: searchData.requestNo,
            userId: searchData.userId,
        };

        setLoading(true);
        genPhotoList(req).then(
            (res) => {
                setLoading(false);
                if (res.data !== undefined) {
                    let temp01 = [];
                    let temp02 = [];
                    let temp03 = [];
                    let temp04 = [];
                    let temp05 = [];
                    let temp06 = [];
                    let index01 = 1;
                    let index02 = 1;
                    let index03 = 1;
                    let index04 = 1;
                    let index05 = 1;
                    let index06 = 1;
                    res.data.forEach((element) => {
                        if (element.photoType === "T001" || element.photoType === "T101" || element.photoType === "T102" ||
                            element.photoType === "T103" || element.photoType === "T104" || element.photoType === "T105" ||
                            element.photoType === "T106" || element.photoType === "T107" || element.photoType === "T108" ||
                            element.photoType === "T109" || element.photoType === "T150" || element.photoType === "T151" ||
                            element.photoType === "T152" || element.photoType === "T153") {
                            temp01.push({
                                ...element,
                                index: index01,
                            });
                            index01++;

                        } else if (element.photoType === "T002" || element.photoType === "T21" || element.photoType === "T22" ||
                            element.photoType === "T23" || element.photoType === "T24" || element.photoType === "T25" ||
                            element.photoType === "T26" || element.photoType === "T27" || element.photoType === "T28" ||
                            element.photoType === "T29" || element.photoType === "T210" || element.photoType === "T211" ||
                            element.photoType === "T212") {

                            temp02.push({
                                ...element,
                                index: index02,
                            });
                            index02++;

                        } else if (element.photoType === "T003" || element.photoType === "T301" || element.photoType === "T302" ||
                            element.photoType === "T311" || element.photoType === "T312" || element.photoType === "T313") {

                            temp03.push({
                                ...element,
                                index: index03,
                            });
                            index03++;

                        } else if (element.photoType === "T004" || element.photoType === "T401" || element.photoType === "T402" ||
                            element.photoType === "T403" || element.photoType === "T404" || element.photoType === "T405" ||
                            element.photoType === "T406" || element.photoType === "T407" || element.photoType === "T408" ||
                            element.photoType === "T409" || element.photoType === "T410" || element.photoType === "T411") {

                            temp04.push({
                                ...element,
                                index: index04,
                            });
                            index04++;

                        } else if (element.photoType === "T005" || element.photoType === "T501" || element.photoType === "T502") {

                            temp05.push({
                                ...element,
                                index: index05,
                            });
                            index05++;

                        } else if (element.photoType === "T006" || element.photoType === "T601" || element.photoType === "T602") {

                            temp06.push({
                                ...element,
                                index: index06,
                            });
                            index06++;

                        }

                    });

                    setDataT001(temp01);
                    setDataT002(temp02);
                    setDataT003(temp03);
                    setDataT004(temp04);
                    setDataT005(temp05);
                    setDataT006(temp06);


                } else {
                    showMessages("error", `เกิดข้อผิดพลาด Status Code: ${res.status}`, `${res.statusText}`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const itemTemplate = (item) => {
        return (<div className="p-grid p-fluid"><Media
            path={item.photoPath}
            alt={item.photoTypeDesc}
            style={{ width: 310, height: 350 }}
        // type ={images}
        />
        </div>
        );
    };

    const caption = (item) => {
        return (
            <React.Fragment>
                <div className="text-xl mb-2 font-bold">{item.photoTypeDesc === null ? "-" : item.photoTypeDesc}</div>
                {/* <p className="text-white">{item.photoTypeDesc}</p> */}
            </React.Fragment>
        );
    }


    const onUploadDialog = (code, dataList) => {
        setDialogPics({ dialog: true, show: false, code: code });
    //setTabCode(code);
    setDataList(dataList)
    };


    const onGenPhotoUpdate = (newData, action) => {
        let req = {
                actionCode: "D",
                originalId: searchData.userId,
                photoDesc: "",
                photoPath: newData.photoPath,
                photoSeq: newData.photoSeq,
                photoType: newData.photoType,
                requestNo: searchData.requestNo,
                thumbnailPath: newData.thumbnailPath,
                userId: searchData.userId,
            };

            console.log("onGenPhotoUpdate : ",req);
       
        setLoading(true);
        genPhotoUpdate(req).then(
            (res) => {
                setLoading(false);

                if (res.status === 200) {
                    
                        if (res.data[0].statusCode === "C") {
                            setTextShow(`บันทึกสมบูรณ์ `);
                            onGenPhotoList();
                            setDialogPics({ dialog: false, show: false, code: "" })
                        } else if (res.data[0].statusCode === "E") {
                            setTextShow(res.data[0].statusText);
                        }
                    
                    // setShowDialog(true);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด Status Code: ${res.status}`, `${res.statusText}`);
                }
                
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };


    return (
        <div>

            <div className="p-grid p-fluid media-demo">

                <div className="p-col-12 p-md-6">
                    <Panel header={"บันทึกแรงงานและเครื่องจักร จำนวน " + dataT001.length + " รูปถ่าย"} toggleable>

                        <div className="p-col-12 p-md-12" >
                            <div className="p-grid p-fluid media-demo ">
                                <div className="p-col-12 p-md-8"></div>
                                <div className="p-col-12 p-md-2">
                                    <Button className="p-button-warning p-component  mb-2" icon="pi pi-plus" label="เพิ่มรูปถ่าย" placeholder="เพิ่มรูปถ่าย" onClick={() => uploadPic("T001")}/>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <Button className="p-button-danger p-component  mb-2" icon="pi pi-trash" label="ลบรูปถ่าย" placeholder="ลบรูปถ่าย" disabled={dataT001.length > 0 ? false : true} onClick={() => onUploadDialog("T001", dataT001)}/>
                                </div>
                            </div>
                        </div>

                        <div className="p-col-12 p-md-12">

                            <div className="card">
                            {dataT001.length  > 0 ? (
                                <Galleria id="T001" value={dataT001} showThumbnails={false} showIndicators item={itemTemplate} showItemNavigators caption={caption} />
                            ) :(<div style={{ border: "1px solid", borderColor: "#EAE6E5", textAlign: "center", padding: "16%", paddingTop: "16%" }}>
                                <i className="pi pi-image" style={{ fontSize: "10rem", color: "#E0E0E0", fontWeight: "bold" }}></i>
                                <br></br>
                                <label style={{ color: "#E0E0E0" }}>Image not found...</label>
                            </div>)}
                            </div>
                        </div>

                    </Panel>
                </div>

                {data.enableTab2 === "Y" ?
                    <div className="p-col-12 p-md-6">
                        <Panel header={"งานก่อสร้าง จำนวน " + dataT002.length + " รูปถ่าย"} toggleable >
                            <div className="p-col-12 p-md-12" >
                                <div className="p-grid p-fluid media-demo ">
                                    <div className="p-col-12 p-md-8"></div>
                                    <div className="p-col-12 p-md-2">
                                        <Button className="p-button-warning p-component  mb-2" icon="pi pi-plus" label="เพิ่มรูปถ่าย" placeholder="เพิ่มรูปถ่าย" onClick={() => uploadPic("T002")}/>
                                    </div>
                                    <div className="p-col-12 p-md-2">
                                        <Button className="p-button-danger p-component  mb-2" icon="pi pi-trash" label="ลบรูปถ่าย" placeholder="ลบรูปถ่าย" disabled={dataT002.length > 0 ? false : true} onClick={() => onUploadDialog("T002", dataT002)}/>
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-12">
                                <div className="card">
                                    {dataT002.length  > 0 ? (
                                        <Galleria id="T002" value={dataT002} showThumbnails={false} showIndicators item={itemTemplate} showItemNavigators caption={caption} />
                                    )
                                        : (<div style={{ border: "1px solid", borderColor: "#EAE6E5", textAlign: "center", padding: "16%", paddingTop: "16%" }}>
                                            <i className="pi pi-image" style={{ fontSize: "10rem", color: "#E0E0E0", fontWeight: "bold" }}></i>
                                            <br></br>
                                            <label style={{ color: "#E0E0E0" }}>Image not found...</label>
                                        </div>)}
                                </div>
                            </div>
                        </Panel>
                    </div> : ""}

                {data.enableTab3 === "Y" ? <div className="p-col-12 p-md-6">
                    <Panel header={"งานตัดบรรจบ จำนวน " + dataT003.length + " รูปถ่าย"} toggleable>
                        <div className="p-col-12 p-md-12" >
                            <div className="p-grid p-fluid media-demo ">
                                <div className="p-col-12 p-md-8"></div>
                                <div className="p-col-12 p-md-2">
                                    <Button className="p-button-warning p-component  mb-2" icon="pi pi-plus" label="เพิ่มรูปถ่าย" placeholder="เพิ่มรูปถ่าย" onClick={() => uploadPic("T003")}/>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <Button className="p-button-danger p-component  mb-2" icon="pi pi-trash" label="ลบรูปถ่าย" placeholder="ลบรูปถ่าย" disabled={dataT003.length > 0 ? false : true} onClick={() => onUploadDialog("T003", dataT003)}/>
                                </div>
                            </div>
                        </div>

                        <div className="p-col-12 p-md-12">
                            <div className="card">
                            {dataT003.length  > 0 ? (
                                <Galleria id="T003" value={dataT003} showThumbnails={false} showIndicators item={itemTemplate} showItemNavigators caption={caption} />
                            ) :(<div style={{ border: "1px solid", borderColor: "#EAE6E5", textAlign: "center", padding: "16%", paddingTop: "16%" }}>
                                <i className="pi pi-image" style={{ fontSize: "10rem", color: "#E0E0E0", fontWeight: "bold" }}></i>
                                <br></br>
                                <label style={{ color: "#E0E0E0" }}>Image not found...</label>
                            </div>)}
                            </div>
                        </div>
                    </Panel>
                </div> : " "}

                {data.enableTab4 === "Y" ? <div className="p-col-12 p-md-6">
                    <Panel header={"งานโครงสร้าง จำนวน " + dataT004.length + " รูปถ่าย"} toggleable>
                        <div className="p-col-12 p-md-12" >
                            <div className="p-grid p-fluid media-demo ">
                                <div className="p-col-12 p-md-8"></div>
                                <div className="p-col-12 p-md-2">
                                    <Button className="p-button-warning p-component  mb-2" icon="pi pi-plus" label="เพิ่มรูปถ่าย" placeholder="เพิ่มรูปถ่าย" onClick={() => uploadPic("T004")}/>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <Button className="p-button-danger p-component  mb-2" icon="pi pi-trash" label="ลบรูปถ่าย" placeholder="ลบรูปถ่าย" disabled={dataT004.length > 0 ? false : true} onClick={() => onUploadDialog("T004", dataT004)}/>
                                </div>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-12">
                            <div className="card">
                            {dataT004.length  > 0 ? (
                                <Galleria id="T004" value={dataT004} showThumbnails={false} showIndicators item={itemTemplate} showItemNavigators caption={caption} />
                            ) :(<div style={{ border: "1px solid", borderColor: "#EAE6E5", textAlign: "center", padding: "16%", paddingTop: "16%" }}>
                                <i className="pi pi-image" style={{ fontSize: "10rem", color: "#E0E0E0", fontWeight: "bold" }}></i>
                                <br></br>
                                <label style={{ color: "#E0E0E0" }}>Image not found...</label>
                            </div>)}
                            </div>
                        </div>
                    </Panel>
                </div> : " "}

                {data.enableTab5 === "Y" ? <div className="p-col-12 p-md-6">
                    <Panel header={"งานซ่อมคืนสภาพ จำนวน " + dataT005.length + " รูปถ่าย"} toggleable>
                        <div className="p-col-12 p-md-12" >
                            <div className="p-grid p-fluid media-demo ">
                                <div className="p-col-12 p-md-8"></div>
                                <div className="p-col-12 p-md-2">
                                    <Button className="p-button-warning p-component  mb-2" icon="pi pi-plus" label="เพิ่มรูปถ่าย" placeholder="เพิ่มรูปถ่าย" onClick={() => uploadPic("T005")}/>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <Button className="p-button-danger p-component  mb-2" icon="pi pi-trash" label="ลบรูปถ่าย" placeholder="ลบรูปถ่าย" disabled={dataT005.length > 0 ? false : true} onClick={() => onUploadDialog("T005", dataT005)}/>
                                </div>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-12">
                            <div className="card">
                            {dataT005.length  > 0 ? (
                                <Galleria id="T005" value={dataT005} showThumbnails={false} showIndicators item={itemTemplate} showItemNavigators caption={caption} />
                            ) :(<div style={{ border: "1px solid", borderColor: "#EAE6E5", textAlign: "center", padding: "16%", paddingTop: "16%" }}>
                                <i className="pi pi-image" style={{ fontSize: "10rem", color: "#E0E0E0", fontWeight: "bold" }}></i>
                                <br></br>
                                <label style={{ color: "#E0E0E0" }}>Image not found...</label>
                            </div>)}
                            </div>
                        </div>
                    </Panel>
                </div> : " "}

                {data.enableTab6 === "Y" ? <div className="p-col-12 p-md-6">
                    <Panel header={"ระบบท่อประปา จำนวน " + dataT006.length + " รูปถ่าย"} toggleable>
                        <div className="p-col-12 p-md-12" >
                            <div className="p-grid p-fluid media-demo ">
                                <div className="p-col-12 p-md-8"></div>
                                <div className="p-col-12 p-md-2">
                                    <Button className="p-button-warning p-component  mb-2" icon="pi pi-plus" label="เพิ่มรูปถ่าย" placeholder="เพิ่มรูปถ่าย" onClick={() => uploadPic("T006")}/>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <Button className="p-button-danger p-component  mb-2" icon="pi pi-trash" label="ลบรูปถ่าย" placeholder="ลบรูปถ่าย" disabled={dataT006.length > 0 ? false : true} onClick={() => onUploadDialog("T006", dataT006)}/>
                                </div>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-12">
                            <div className="card">
                            {dataT006.length  > 0 ? (
                                <Galleria id="T006" value={dataT006} showThumbnails={false} showIndicators item={itemTemplate} showItemNavigators caption={caption} />
                            ) :(<div style={{ border: "1px solid", borderColor: "#EAE6E5", textAlign: "center", padding: "16%", paddingTop: "16%" }}>
                                <i className="pi pi-image" style={{ fontSize: "10rem", color: "#E0E0E0", fontWeight: "bold" }}></i>
                                <br></br>
                                <label style={{ color: "#E0E0E0" }}>Image not found...</label>
                            </div>)}
                            </div>
                        </div>
                    </Panel>
                </div> : " "}

            </div>

            <P206DeletePicList dialog={dialogPics} setDialog={setDialogPics} searchData={searchData} tabCode={tabCode} dataList={dataList} onGenPhotoUpdate={onGenPhotoUpdate}/>
            <DialogShow visible={showDialog} header="แจ้งเตือน" modal onHide={() => setShowDialog(false)} className="p-fluid" textContent={textShow} btnCancle={() => setShowDialog(false)} />
        </div>
    )
}